// Kpis
import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/pinterest/avgEngagementRateHistory';
// Charts
import { followerGrowthHistoryConfig } from '@/lib/analytics/charts/pinterest/followerGrowthHistory';
import { avgEngagementRateOnImpressionsConfig } from '@/lib/analytics/kpis/pinterest/avgEngagementRateOnImpressions';
import { avgEngagementRatePerPinConfig } from '@/lib/analytics/kpis/pinterest/avgEngagementRatePerPin';
import { clicksConfig } from '@/lib/analytics/kpis/pinterest/clicks';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/pinterest/followersEvolution';
import { followersEvolutionPercentageConfig } from '@/lib/analytics/kpis/pinterest/followersEvolutionPercentage';
import { impressionsConfig } from '@/lib/analytics/kpis/pinterest/impressions';
import { outboundClicksConfig } from '@/lib/analytics/kpis/pinterest/outboundClicks';
import { totalEngagementConfig } from '@/lib/analytics/kpis/pinterest/totalEngagement';
import { totalFollowersConfig } from '@/lib/analytics/kpis/pinterest/totalFollowers';
import { totalPinsConfig } from '@/lib/analytics/kpis/pinterest/totalPins';
// Medias Widgets
import { mostRecentPinsConfig } from '@/lib/analytics/widget/pinterest/mostRecentPinsConfig';

export const OverviewPinterest = [
    totalFollowersConfig,
    followersEvolutionConfig,
    followersEvolutionPercentageConfig,

    followerGrowthHistoryConfig,
    avgEngagementRateHistoryConfig,

    impressionsConfig,
    totalPinsConfig,
    totalEngagementConfig,

    avgEngagementRatePerPinConfig,
    avgEngagementRateOnImpressionsConfig,

    clicksConfig,
    outboundClicksConfig,

    mostRecentPinsConfig
];

export const requestPinterestParams = [
    [
        'followers',
        'followers_evolution',
        'followers_evolution_percentage',
        'pins',
        'impressions',
        'follower_growth_history',
        'average_engagement_rate_history',
        'engagement',
        'average_engagement_rate_per_pin',
        'average_engagement_rate_on_impressions',
        'pin_clicks',
        'outbound_clicks'
    ]
];
